<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
	title: {
		type: String,
		required: false,
		default: ''
	},
	editable: {
		default: false
	},
	replaceInnerText: {
		type: Boolean,
		default: false
	},
	editClass: {
		type: String,
		default: 'title-editable'
	},
	titleClasses: {
		type: String,
		default: 'font-medium text-base rounded min-w-0'
	},
	maxWidth: {
		type: String,
		default: 'lg:max-w-[500px]'
	}
})

const emit = defineEmits({
  'changed': () => true,
  'edit': () => true
})

const titleWrapper = ref(null)
const allowEditTitle = ref(false)

const editTitle = () => {
	if (props.editable) {
		allowEditTitle.value = true
		emit('edit', allowEditTitle.value)
		setTimeout(() => {
			titleWrapper.value.focus()
		}, "100")
	}
}
const saveNewTitle = (e) => {
	// Enter blurs, so blur is the only save path; a blur after editing ended is ignored.
	if (!allowEditTitle.value) return
	const newName = e.target.innerText.trim()

	if (newName.length <= 1) {
		e.target.innerText = props.title
		allowEditTitle.value = false
		emit('edit', allowEditTitle.value)
		return
	}
	if (newName !== props.title) emit('changed', newName)
	allowEditTitle.value = false
	if (props.replaceInnerText) e.target.innerText = props.title
	emit('edit', allowEditTitle.value)
}

const editClassComputed = computed(() => allowEditTitle.value ? props.editClass : '')

defineExpose({ editTitle })
</script>

<template>
	<h2 ref="titleWrapper" :class="[titleClasses, editClassComputed, allowEditTitle ? 'break-all' : 'truncate', maxWidth]" :title="title" :contenteditable="allowEditTitle"
	@click="editTitle()" @blur="saveNewTitle" @keydown.enter.prevent="$event.target.blur()" v-text="title" />
	<!-- <h2 :class="[titleClasses, editClassComputed]" :title="title">
		<span ref="titleWrapper" class="block w-full" @blur="saveNewTitle" @keyup.enter="saveNewTitle" :class="allowEditTitle ? 'break-all' : 'truncate'" :contenteditable="allowEditTitle" v-text="title" @click="editTitle()" />
	</h2> -->
</template>

<style scoped>
.title-editable {
	-webkit-user-modify: read-write-plaintext-only;
	outline: none;
	cursor: text;
	background-color: var(--surface-3);
	box-shadow: inset 0 0 0 1px var(--c-main);
}
</style>
